import { GET_PIECE_PART_TYPE } from "../../../../constant/asynActionsType";
import { createAppAsyncThunk } from "../../../../utils/createAppAsyncThunk";
import { GetPiecePartService } from "./purchaseServices";

export const getPiecePart = createAppAsyncThunk(
  GET_PIECE_PART_TYPE,
  GetPiecePartService,
  {}
);
